import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'translations';
import wait from 'util/misc/wait';
import ruit from 'ruit';
import classnames from 'classnames';
import { formatPrice } from 'util/misc/format-price';
import { CURRENCY } from 'constants/cart';

/* eslint-disable camelcase */
const ANIMATION_DELAY = 1000;

export default class BagsProgressbar extends PureComponent {
    static defaultProps = {
        bagInfo: {},
        oldBagInfo: {},
    };

    static propTypes = {
        price: PropTypes.string.isRequired,
        oldBagInfo: PropTypes.object,
        bagInfo: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.currentPerc = props.oldBagInfo.non_full_bag_percentage;

        this.state = {
            isAnimated: true,
            perc: this.currentPerc,
        };
    }

    componentDidMount() {
        this.handleBagsTransition(this.props.bagInfo, this.props.oldBagInfo);
    }

    componentWillReceiveProps(newProps) {
        this.handleBagsTransition(newProps.bagInfo, this.props.bagInfo);
    }

    componentWillUnmount() {
        this.clearAsync();
    }

    clearAsync = () => {
        if (this.timer) {
            this.timer.cancel();
        }
    };

    handleBagsTransition(newBagInfo, oldBagInfo) {
        const { non_full_bag_percentage, total_bags } = newBagInfo;
        const { total_bags: oldTotalBags, non_full_bag_percentage: oldPerc } = oldBagInfo;

        // cache the current percentage to have it always updated
        this.currentPerc = non_full_bag_percentage || 0;

        if (non_full_bag_percentage !== oldPerc) {
            // defer the update
            if (oldTotalBags && total_bags && total_bags !== oldTotalBags) {
                this.runAnimationQueue({ total_bags, oldTotalBags });
            } else if (!this.timer) {
                this.setState({
                    isAnimated: true,
                    perc: non_full_bag_percentage,
                });
            }
        }
    }

    runAnimationQueue = ({ total_bags, oldTotalBags }) => {
        return ruit(
            this.clearAsync(),
            this.setState({
                perc: total_bags > oldTotalBags ? 100 : 0,
                isAnimated: true,
            }),
            this.wait(ANIMATION_DELAY),
            () => this.setState({
                isAnimated: false,
                perc: total_bags > oldTotalBags ? 0 : 100,
            }),
            this.wait(ANIMATION_DELAY),
            () => this.setState({
                isAnimated: true,
                perc: this.currentPerc,
            }),
        ).then(() => {
            this.timer = null;
        });
    };

    timer = null;

    wait = (delay) => {
        this.timer = wait(delay)();
        return this.timer;
    };


    render() {
        const { bagInfo, price } = this.props;
        const { perc, isAnimated } = this.state;
        const total_bags = bagInfo.total_bags || 0;

        return (
            <div className="bags-progressbar">
                <h2 className="bags-progressbar--title u-reset"><Trans path="snackbar.cart.title" amount={total_bags}
                    data={{ amount: total_bags }}/></h2>
                <div className="bags-progressbar--row">
                    <p className="bags-progressbar--description"><Trans path="snackbar.cart.description"
                        data={{ price: formatPrice(price), currency: CURRENCY }}/></p>
                    <p className="bags-progressbar--optional-text bags-progressbar--optional-text__top"><Trans
                        path="snackbar.cart.optional_text"/></p>
                </div>
                <div className="bags-progressbar--bar">
                    <div ref="bar"
                        className={classnames('bags-progressbar--value', { 'bags-progressbar--value__is-animated': isAnimated })}
                        style={{ width: `${ perc }%` }}/>
                </div>
                <p className="bags-progressbar--optional-text bags-progressbar--optional-text__bottom"><Trans
                    path="snackbar.cart.optional_text"/></p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/snackbar/notifications/bags-progressbar/index.js